import React from 'react';
import { useTranslation } from 'react-i18next';

// Section "Parrainage" du règlement — transverse foot/rugby
export const ReferralRulesSection = () => {
    const { t } = useTranslation();

    return (
        <section>
            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider flex items-center gap-1.5">
                <span>🤝</span> {t('referral_rules.title', 'Ramène tes potes (et gagnez à deux)')}
            </h3>

            <p className="mb-3">
                {t('referral_rules.intro', "Le jeu est toujours plus fun à plusieurs. Partage ton lien perso : pour chaque ami qui joue, vous gagnez chacun une récompense.")}
            </p>

            <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-3 mb-3 flex items-start gap-3">
                <span className="text-lg">🎁</span>
                <p className="text-[12px] text-emerald-800 leading-snug">
                    <strong>{t('referral_rules.reward_label', 'Deux gagnants.')}</strong>{' '}
                    {t('referral_rules.reward_content', "Ton ami repart avec une récompense, et toi aussi. Tout le monde y gagne. 🎁🎁")}
                </p>
            </div>

            <p className="mb-3 text-[12px]">
                {t('referral_rules.rule', "Réservé aux vrais nouveaux joueurs, dans la limite de ton quota d'invitations. Pas de robots ni de faux comptes — on invite des vrais potes !")}
            </p>

            <p className="text-[12px] text-gray-400 italic">
                📍 {t('referral_rules.availability', "Le parrainage n'est ouvert que si l'établissement propose l'offre.")}
            </p>
        </section>
    );
};
